export type TaskType = {
  id: string;
  name: string;
  done: boolean;
};

export const cardTypes = {
  CARD: 'card',
};
